package com.essntl.features.request.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [RequestSupabaseDataSource::class])
internal class RequestSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<RequestDto> {
    override val tableName: String = "request"
}
